import api from './index';

export default {
  // Obtener todos los envios
  async getEnvios(page = 1, pageSize = 10, search='') {
    try {
      const response = await api.get('/envios', {
        params: {
          page,
          pageSize: pageSize,
          search
        }
      });
      return response.data;
      
    } catch (error) {
      console.error('Error al obtener envios:', error);
      throw error;
    }
  },

  // Obtener detalles de un envio
  async getEnvioDetails(id: number) {
    try {
      const response = await api.get(`/envios/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener detalles del envio:', error);
      throw error;
    }
  },

  async createEnvio(data: any) {
    try {
      const response = await api.post('/envios/', data);
      return response.data;
    } catch (error) {
      console.error('Error al crear el envio:', error)
    }
  },

  // Actualizar un envio
  async updateEnvio(id: number, data: any) {
    try {
      const response = await api.patch(`/envios/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar el Envio', error);
      throw error;
    }
  },

  // Buscar envios por término
  async searchEnvios(query: string) {
    try {
      const response = await api.get('/envios/search', {
        params: { q: query },
      });
      return response.data;
    } catch (error) {
      console.error('Error al buscar envios:', error);
      throw error;
    }
  },
};